<template>
  <div class="baseSelector">
    <h4 class="col-md-3 baseSelector__title">{{ title }}</h4>
    <div class="col-md-3 col-sm-3">
      <select
        class="baseSelector__select row"
        :value="selectValue"
        @change="selectChangeHandler($event)"
      >
        <option
          v-for="(option, index) in options"
          :value="option.value"
          :key="index"
        >
          {{ option.description }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    options: {
      type: Array,
    },
    selectValue: {
      type: Number,
    },
  },
  methods: {
    selectChangeHandler(event) {
      const { value } = event.target
      this.$emit('selectChangeHandler', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.baseSelector {
  &__title {
    margin: 0;
    font-size: 18px;
    color: black;
    height: 36px;
    line-height: 36px;
  }

  &__select {
    width: 100%;
    min-width: 85px; //有最小寬度字才不會被下拉的icon擋住
    height: 36px;
    padding: 6px 12px;
    font-size: 18px;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/select/BaseSelector.vue